export const purificationCalculator = {
  pageTitle: "Stock purification calculator",
  eyebrow: "Dividends & purification",
  subtitle:
    "Estimate how much of the dividends you received should be purified, using Akinda's non-compliant revenue ratio. For HALAL and DOUBTFUL stocks only. Education only — not a fatwa.",
  inputsHeading: "Your holding",
  tickerLabel: "Stock",
  tickerTooltip:
    "Search and select a ticker. Purification uses Akinda's latest non-compliant revenue ratio.",
  tickerPlaceholder: "Search stocks...",
  selectedTicker: "Selected: {{ticker}}",
  dividendsLabel: "Dividends received",
  dividendsTooltip:
    "Total cash dividends you received from this stock, in USD. Capital gains are not included.",
  calculate: "Calculate",
  reset: "Reset",
  statPurification: "Amount to purify",
  statRatio: "Non-compliant revenue",
  statDividends: "Dividends received",
  outcomeHeadline: "Purify {{amount}} from {{ticker}} dividends.",
  statusLabel: "Shariah status",
  statusHalal: "Halal",
  statusDoubtful: "Doubtful",
  viewReport: "View full stock report",
  formula: "{{dividends}} × {{ratio}}% = {{amount}}",
  errorNotHalal:
    "This stock is not halal. Purification is not calculated for non-compliant companies.",
  errorUnavailable: "Purification data is not available for this stock.",
  errorNotFound: "Stock not found.",
  errorInvalid: "Enter a valid ticker and a dividends amount of zero or more.",
  errorGeneric: "Could not calculate purification. Try again.",
  faq1Title: "What is purification?",
  faq1Body:
    "If a company earns a small share of income from non-compliant sources, many scholars recommend giving away that share of any dividends you received.",
  faq2Title: "Why dividends only?",
  faq2Body:
    "This calculator follows the income-ratio method on cash dividends. It does not cover capital gains or a full portfolio.",
  faq3Title: "Which stocks can I calculate?",
  faq3Body:
    "Halal and doubtful stocks with a published non-compliant revenue ratio. Not-halal stocks and missing data are not shown as $0.",
  disclaimer:
    "This calculator is for general illustration only and is not a fatwa. Ratios can change with new financials. Akinda does not provide personalized religious or financial advice.",
} as const;
